import { bool, node } from "prop-types";
import { observer } from "mobx-react";
import { Tables } from "@repo/utils";
import {
  useEstimateEditorSettings,
  useEstimateEditorStore,
} from "@tools";
import { Grid } from "@material-ui/core";
import useStyle from "@tools/EstimateEditor/styles/CommonTableStyles.style";
import classnames from "classnames";

export const TableBreakdownContainer = observer(({
  children,
  isLastTable,
}) => {
  // const structure = useEstimateStructure();
  const { isAiGenerating } = useEstimateEditorStore();
  const { showPdfCover, previewMode, isPdfPrinterView } = useEstimateEditorSettings();
  const classes = useStyle();
  
  // const { visibleBreakdownColumns } = structure.settings;
  
  // const columnWidthClasses = useColumnWidthClasses(isProposal, visibleBreakdownColumns)();
  
  return (
    <Grid
      item container
      id={Tables.BREAKDOWN}
      className={classnames(
        "vCon",
        showPdfCover && "pdf-mode",
        previewMode && "preview-mode",
        isPdfPrinterView && "printer-mode",
        classes.root,
        // columnWidthClasses.root,
        (isLastTable || isAiGenerating) && !isPdfPrinterView && classes.paddingBottom,
      )}
    >
      { children }
    </Grid>
  )
})

TableBreakdownContainer.propTypes = {
  children: node.isRequired,
  isLastTable: bool,
}